<script lang="ts">
  import type { LayoutProps } from './$types';
  import { page } from '$app/state';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faPenToSquare } from '@itdev-fortawesome/pro-regular-svg-icons/faPenToSquare';
  import { formatDate, isClassOpen, utcNowIso } from '$lib/util';

  let { children, params, data }: LayoutProps = $props();
  let classId = parseInt(params.id);

  let activePage: 'skills' | 'badges' | 'leaderboard' = $derived.by(() => {
    if (page.route.id === '/(loginwrapper)/classes/[id]/(tablayout)/badges') {
      return 'badges';
    }

    if (page.route.id === '/(loginwrapper)/classes/[id]/(tablayout)/leaderboard') {
      return 'leaderboard';
    }

    return 'skills';
  });

  const utcNow = utcNowIso();
</script>

<main id="main-container" class="container narrow py-3">
  {#await data.classPromise then leaderboard}
    <h2>{leaderboard.class.name}</h2>
    {#if utcNow > leaderboard.class.endDate}
      <p class="small fst-italic">Class & leaderboard closed {formatDate(leaderboard.class.endDate)}</p>
    {:else if utcNow < leaderboard.class.startDate}
      <p class="small fst-italic">Class & leaderboard opens {formatDate(leaderboard.class.startDate)}</p>
    {/if}
  {/await}
  <ul class="nav nav-pills">
    {@render tab(`/classes/${classId}`, 'Skills', activePage === 'skills')}
    {@render tab(`/classes/${classId}/badges`, 'Badges', activePage === 'badges')}
    {@render tab(`/classes/${classId}/leaderboard`, 'Leaderboard', activePage === 'leaderboard')}
  </ul>
  {@render children?.()}

  {#snippet tab(link: string, text: string, active: boolean)}
    <li class="nav-item">
      <a class="nav-link" class:active aria-current={active ? 'page' : undefined} href={link}>{text}</a>
    </li>
  {/snippet}
</main>
{#await data.classPromise then leaderboard}
  {#if isClassOpen(leaderboard.class)}
    <div class="floating-action-btn-container">
      <a href="/classes/{classId}/log" class="btn btn-primary floating-action-btn" aria-label="Click to log skills">
        <FontAwesomeIcon icon={faPenToSquare} />
      </a>
    </div>
  {/if}
{/await}

<style>
  .nav {
    --bs-nav-pills-link-active-bg: var(--bs-secondary-bg);
    --bs-nav-link-font-size: 16px;
    --bs-nav-pills-link-active-color: black;
    --bs-nav-link-color: var(--bs-secondary-color);
    border-bottom: 2px var(--bs-secondary-bg) solid;
    margin-bottom: 1rem;
  }

  .nav-item {
    margin-bottom: -2px;
  }

  .nav-pills .nav-link {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    --bs-nav-link-padding-x: 1rem;
    --bs-nav-link-padding-y: 0.4rem;
  }

  .floating-action-btn-container {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
  }

  .floating-action-btn {
    right: 1rem;
    z-index: 100;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
    border-radius: 100px;
    font-size: 1.2em;
    width: 50px;
    height: 50px;
    padding: 0;
    /* pixel-perfect shifts because when perfectly centered, the icon doesn't look quite right */
    padding-bottom: 3px;
    padding-left: 2px;
    display: grid;
    align-items: center;
    justify-content: center;
  }
</style>
